export const LOADING = 'LOADING';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const CREATE_BREADCRUMB = 'CREATE_BREADCRUMB'
export const ADD_TO_BREADCRUMB = 'ADD_TO_BREADCRUMB'
export const REMOVE_FROM_BREADCRUMB = 'REMOVE_FROM_BREADCRUMB'
export const COLLAPSE_SIDEBAR = 'COLLAPSE_SIDEBAR'
export const UPDATE_FAVOURITE_LIST = 'UPDATE_FAVOURITE_LIST'